"use strict";

var _slicedToArray = require("/var/www/repository/Production-Zocial-AdminPanel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _classCallCheck = require("/var/www/repository/Production-Zocial-AdminPanel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParsedMessage = void 0;
var api_1 = __importDefault(require("apg-js/src/apg-api/api"));
var node_exports_1 = __importDefault(require("apg-js/src/apg-lib/node-exports"));
var GRAMMAR = "\nsign-in-with-ethereum =\n    domain %s\" wants you to sign in with your Ethereum account:\" LF\n    address LF\n    LF\n    [ statement LF ]\n    LF\n    %s\"URI: \" URI LF\n    %s\"Version: \" version LF\n    %s\"Chain ID: \" chain-id LF\n    %s\"Nonce: \" nonce LF\n    %s\"Issued At: \" issued-at\n    [ LF %s\"Expiration Time: \" expiration-time ]\n    [ LF %s\"Not Before: \" not-before ]\n    [ LF %s\"Request ID: \" request-id ]\n    [ LF %s\"Resources:\"\n    resources ]\n\ndomain = authority\n\naddress = \"0x\" 40*40HEXDIG\n    ; Must also conform to captilization\n    ; checksum encoding specified in EIP-55\n    ; where applicable (EOAs).\n\nstatement = 1*( reserved / unreserved / \" \" )\n    ; The purpose is to exclude LF (line breaks).\n\nversion = \"1\"\n\nnonce = 8*( ALPHA / DIGIT )\n\nissued-at = date-time\nexpiration-time = date-time\nnot-before = date-time\n\nrequest-id = *pchar\n\nchain-id = 1*DIGIT\n    ; See EIP-155 for valid CHAIN_IDs.\n\nresources = *( LF resource )\n\nresource = \"- \" URI\n\n; ------------------------------------------------------------------------------\n; RFC 3986\n\nURI           = scheme \":\" hier-part [ \"?\" query ] [ \"#\" fragment ]\n\nhier-part     = \"//\" authority path-abempty\n              / path-absolute\n              / path-rootless\n              / path-empty\n\nscheme        = ALPHA *( ALPHA / DIGIT / \"+\" / \"-\" / \".\" )\n\nauthority     = [ userinfo \"@\" ] host [ \":\" port ]\nuserinfo      = *( unreserved / pct-encoded / sub-delims / \":\" )\nhost          = IP-literal / IPv4address / reg-name\nport          = *DIGIT\n\nIP-literal    = \"[\" ( IPv6address / IPvFuture  ) \"]\"\n\nIPvFuture     = \"v\" 1*HEXDIG \".\" 1*( unreserved / sub-delims / \":\" )\n\nIPv6address   =                            6( h16 \":\" ) ls32\n              /                       \"::\" 5( h16 \":\" ) ls32\n              / [               h16 ] \"::\" 4( h16 \":\" ) ls32\n              / [ *1( h16 \":\" ) h16 ] \"::\" 3( h16 \":\" ) ls32\n              / [ *2( h16 \":\" ) h16 ] \"::\" 2( h16 \":\" ) ls32\n              / [ *3( h16 \":\" ) h16 ] \"::\"    h16 \":\"   ls32\n              / [ *4( h16 \":\" ) h16 ] \"::\"              ls32\n              / [ *5( h16 \":\" ) h16 ] \"::\"              h16\n              / [ *6( h16 \":\" ) h16 ] \"::\"\n\nh16           = 1*4HEXDIG\nls32          = ( h16 \":\" h16 ) / IPv4address\nIPv4address   = dec-octet \".\" dec-octet \".\" dec-octet \".\" dec-octet\ndec-octet     = DIGIT                 ; 0-9\n                 / %x31-39 DIGIT         ; 10-99\n                 / \"1\" 2DIGIT            ; 100-199\n                 / \"2\" %x30-34 DIGIT     ; 200-249\n                 / \"25\" %x30-35          ; 250-255\n\nreg-name      = *( unreserved / pct-encoded / sub-delims )\n\npath-abempty  = *( \"/\" segment )\npath-absolute = \"/\" [ segment-nz *( \"/\" segment ) ]\npath-rootless = segment-nz *( \"/\" segment )\npath-empty    = 0pchar\n\nsegment       = *pchar\nsegment-nz    = 1*pchar\n\npchar         = unreserved / pct-encoded / sub-delims / \":\" / \"@\"\n\nquery         = *( pchar / \"/\" / \"?\" )\n\nfragment      = *( pchar / \"/\" / \"?\" )\n\npct-encoded   = \"%\" HEXDIG HEXDIG\n\nunreserved    = ALPHA / DIGIT / \"-\" / \".\" / \"_\" / \"~\"\nreserved      = gen-delims / sub-delims\ngen-delims    = \":\" / \"/\" / \"?\" / \"#\" / \"[\" / \"]\" / \"@\"\nsub-delims    = \"!\" / \"$\" / \"&\" / \"'\" / \"(\" / \")\"\n              / \"*\" / \"+\" / \",\" / \";\" / \"=\"\n\n; ------------------------------------------------------------------------------\n; RFC 3339\n\ndate-fullyear   = 4DIGIT\ndate-month      = 2DIGIT  ; 01-12\ndate-mday       = 2DIGIT  ; 01-28, 01-29, 01-30, 01-31 based on\n                          ; month/year\ntime-hour       = 2DIGIT  ; 00-23\ntime-minute     = 2DIGIT  ; 00-59\ntime-second     = 2DIGIT  ; 00-58, 00-59, 00-60 based on leap second\n                          ; rules\ntime-secfrac    = \".\" 1*DIGIT\ntime-numoffset  = (\"+\" / \"-\") time-hour \":\" time-minute\ntime-offset     = \"Z\" / time-numoffset\n\npartial-time    = time-hour \":\" time-minute \":\" time-second\n                  [time-secfrac]\nfull-date       = date-fullyear \"-\" date-month \"-\" date-mday\nfull-time       = partial-time time-offset\n\ndate-time       = full-date \"T\" full-time\n\n; ------------------------------------------------------------------------------\n; RFC 5234\n\nALPHA          =  %x41-5A / %x61-7A   ; A-Z / a-z\nLF             =  %x0A\n                  ; linefeed\nDIGIT          =  %x30-39\n                  ; 0-9\nHEXDIG         =  DIGIT / \"A\" / \"B\" / \"C\" / \"D\" / \"E\" / \"F\"\n";
var ParsedMessage = function ParsedMessage(msg) {
  _classCallCheck(this, ParsedMessage);
  var api = new api_1.default(GRAMMAR);
  api.generate();
  if (api.errors.length) {
    console.error(api.errorsToAscii());
    console.error(api.linesToAscii());
    console.log(api.displayAttributeErrors());
    throw new Error("ABNF grammar has errors");
  }
  var grammarObj = api.toObject();
  var parser = new node_exports_1.default.parser();
  parser.ast = new node_exports_1.default.ast();
  var id = node_exports_1.default.ids;
  var domain = function domain(state, chars, phraseIndex, phraseLength, data) {
    var ret = id.SEM_OK;
    if (state === id.SEM_PRE) {
      data.domain = node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
    }
    return ret;
  };
  parser.ast.callbacks.domain = domain;
  var address = function address(state, chars, phraseIndex, phraseLength, data) {
    var ret = id.SEM_OK;
    if (state === id.SEM_PRE) {
      data.address = node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
    }
    return ret;
  };
  parser.ast.callbacks.address = address;
  var statement = function statement(state, chars, phraseIndex, phraseLength, data) {
    var ret = id.SEM_OK;
    if (state === id.SEM_PRE) {
      data.statement = node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
    }
    return ret;
  };
  parser.ast.callbacks.statement = statement;
  var uri = function uri(state, chars, phraseIndex, phraseLength, data) {
    var ret = id.SEM_OK;
    if (state === id.SEM_PRE) {
      if (!data.uri) {
        data.uri = node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
      }
    }
    return ret;
  };
  parser.ast.callbacks.uri = uri;
  var version = function version(state, chars, phraseIndex, phraseLength, data) {
    var ret = id.SEM_OK;
    if (state === id.SEM_PRE) {
      data.version = node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
    }
    return ret;
  };
  parser.ast.callbacks.version = version;
  var chainId = function chainId(state, chars, phraseIndex, phraseLength, data) {
    var ret = id.SEM_OK;
    if (state === id.SEM_PRE) {
      data.chainId = parseInt(node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength));
    }
    return ret;
  };
  parser.ast.callbacks['chain-id'] = chainId;
  var nonce = function nonce(state, chars, phraseIndex, phraseLength, data) {
    var ret = id.SEM_OK;
    if (state === id.SEM_PRE) {
      data.nonce = node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
    }
    return ret;
  };
  parser.ast.callbacks.nonce = nonce;
  var issuedAt = function issuedAt(state, chars, phraseIndex, phraseLength, data) {
    var ret = id.SEM_OK;
    if (state === id.SEM_PRE) {
      data.issuedAt = node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
    }
    return ret;
  };
  parser.ast.callbacks['issued-at'] = issuedAt;
  var expirationTime = function expirationTime(state, chars, phraseIndex, phraseLength, data) {
    var ret = id.SEM_OK;
    if (state === id.SEM_PRE) {
      data.expirationTime = node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
    }
    return ret;
  };
  parser.ast.callbacks['expiration-time'] = expirationTime;
  var notBefore = function notBefore(state, chars, phraseIndex, phraseLength, data) {
    var ret = id.SEM_OK;
    if (state === id.SEM_PRE) {
      data.notBefore = node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
    }
    return ret;
  };
  parser.ast.callbacks['not-before'] = notBefore;
  var requestId = function requestId(state, chars, phraseIndex, phraseLength, data) {
    var ret = id.SEM_OK;
    if (state === id.SEM_PRE) {
      data.requestId = node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
    }
    return ret;
  };
  parser.ast.callbacks['request-id'] = requestId;
  var resources = function resources(state, chars, phraseIndex, phraseLength, data) {
    var ret = id.SEM_OK;
    if (state === id.SEM_PRE) {
      data.resources = node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength).slice(3).split('\n- ');
    }
    return ret;
  };
  parser.ast.callbacks.resources = resources;
  var result = parser.parse(grammarObj, 'sign-in-with-ethereum', msg);
  if (!result.success) {
    throw new Error("Invalid message: ".concat(JSON.stringify(result)));
  }
  var elements = {};
  parser.ast.translate(elements);
  for (var _i = 0, _Object$entries = Object.entries(elements); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    this[key] = value;
  }
};
exports.ParsedMessage = ParsedMessage;